import { render, staticRenderFns } from "./SchoolClassEdit.vue?vue&type=template&id=2bb4a27d"
import script from "./SchoolClassEdit.vue?vue&type=script&lang=js"
export * from "./SchoolClassEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports